import React, { useContext, useEffect, useState } from 'react'

import { getBackendData } from '../../api/api'
import { IRuneDistribution } from '../../api/interfaces'
import { ThemeContext } from '../../App'
import { IChart } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { useChartData } from '../../hooks/useChartData'

async function getRuneDistributionConfig(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorchain', 'tc_rune_distribution', timeframe)) as IRuneDistribution[]
	const series1 = chartData.map((element: IRuneDistribution) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.RICH_COUNT_100k }
	})
	console.log(series1)
	const series2 = chartData.map((element: IRuneDistribution) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.RICH_COUNT_10k }
	})
	const series3 = chartData.map((element: IRuneDistribution) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.RICH_COUNT_1k }
	})
	const series4 = chartData.map((element: IRuneDistribution) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.RICH_COUNT_100 }
	})
	const config: IChart[] = [
		{
			data: series1,
			strokeWidth: 2,
			name: 'Wallets with >= 100k ᚱ',
			type: 'line',
			seriesGroup: '[wallet #]',
			color: 'green'
		},
		{
			data: series2,
			strokeWidth: 2,
			name: 'Wallets with >= 10k ᚱ',
			type: 'line',
			seriesGroup: '[wallet #]',
			color: 'orange'
		},
		{
			data: series3,
			strokeWidth: 2,
			name: 'Wallets with >= 1k ᚱ',
			type: 'line',
			seriesGroup: '[wallet #]',
			color: `${color}`
		},
		{
			data: series4,
			strokeWidth: 2,
			name: 'Wallets with >= 100 ᚱ',
			type: 'line',
			seriesGroup: '[wallet #]',
			color: 'red'
		}
	]
	return { config: config, latestValue: series2[series2.length - 1].y, latestValueDate: series2[series2.length - 1].x }
}
const RuneDistribution = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getRuneDistributionConfig, '1m')

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}
	return (
		<ChartPage
			chartTitle="RUNE Distribution"
			chartDesc="RUNE distribution across different value brackets."
			chartDescTitle="Metric Description"
			chartData={dataSeries.config}
			queryId="a5d0b143-2423-46e3-9394-f31e68de5454"
			timeframe={timeframe}
			setTimeframe={setTimeframe}
			hasHours={false}
			hasLogScale={true}
			reverseLegend={true}
		/>
	)
}

export default RuneDistribution
